import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { yupErrorMsg } from '../../../components/atoms/const';
import api from '../../../components/api';

function useForgotPassword() {
  /* state management for react query fetch management */
  const { isLoading, mutate } = useMutation(api.auth.postForgotPassword, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => console.log(res),
    onError: (err) => console.log('err', err),
  });

  /* will navigate page to root /login */
  const navigate = useNavigate();
  const navigateToLogin = () => {
    navigate('/login');
  };

  /* form validation */
  const yupSchema = yup.object({
    username: yup.string().email(yupErrorMsg.EMAIL_INCORRECT_FORMAT).required(yupErrorMsg.EMAIL_EMPTY),
  });

  /* form handler */
  const formik = useFormik({
    initialValues: {
      username: '',
    },
    validationSchema: yupSchema,
    onSubmit: async (values) => {
      console.log(values);
      mutate(values);
    },
  });

  return {
    navigateToLogin, formik, isLoading,
  };
}

export default useForgotPassword;
